/* eslint-disable */
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import * as context from 'api/base';
import Icon from '@mui/material/Icon';
import { Link } from 'react-router-dom';

//Custom SVG
import iconPlane from '../../../../../assets/icons/icon_plane.svg';
import { getNewBuyInsurancePathGeneric } from '../../routes/generic/Helpers/HomePageHelper';
import { useSelector } from 'react-redux';
import { getPagesButtonName } from '../../routes/generic/Helpers/GenericHelper';
import { useStylesProductDetailsCard } from '../styles/widgetStyles';

function ProductDetailedCardWidget(props) {
	let themeinfo = context.getSettings();
	const channelProducts = useSelector(({ fuse }) => fuse.form.channelProducts);
	const referenceTokenDetails = useSelector(({ fuse }) => fuse.form.referenceTokenDetails);
	const myHostPrefix = useSelector(({ fuse }) => fuse.form.mySite.hostPrefix);
	const classes = useStylesProductDetailsCard(themeinfo);

	let productInfo = context.getProducts();

	const prodItems = [];
	productInfo.forEach(pitem =>
		prodItems.push(
			<Grid key={pitem - name} item className="w-full max-w-480 text-left sm:w-1/2 p-12">
				<Card sx={classes.card} className="rounded-10">
					<div className="px-24 py-16" style={classes.cardHeader}>
						<Typography variant="h4" className="font-bold mr-10">
							<Icon fontSize="inherit" sx={classes.cardIcon}>
								<img src={iconPlane} />
							</Icon>
							{pitem.contents['PRODUCT-NAME']}
						</Typography>
					</div>

					<CardContent className="p-32">
						<div className="flex flex-col">
							<div dangerouslySetInnerHTML={{ __html: pitem.contents['PRODUCT-DESCRIPTION'] }} /> <br />
							<Link to={`/fast-facts-products/${pitem.instanceId}`}>
								<strong style={classes.cardClickForMore}>[Fast Facts Comparison]</strong>
							</Link>
						</div>
					</CardContent>

					<div style={classes.cardFooter} className="flex pb-32">
						<div style={classes.cardButtonMain}>
							<Button
								sx={classes.cardButton}
								component={Link}
								to={getNewBuyInsurancePathGeneric(
									channelProducts,
									referenceTokenDetails?.token,
									myHostPrefix
								)}
								variant="contained"
								color="primary"
								name={getPagesButtonName({
									pageName: 'Landing',
									buttonName: `${pitem.contents['OPTION-NAME']} Get Cover Now`
								})}
								data-ga-label={`product-card-get-cover-now-${pitem?.instanceId?.split('-')?.pop()}`}
							>
								Get Cover Now
							</Button>
						</div>
					</div>
				</Card>
			</Grid>
		)
	);

	return (
		<div className="w-full">
			<div className="">
				<div className="w-full max-w-2xl mx-auto">
					<Grid container className="flex justify-center flex-wrap">
						{prodItems}
					</Grid>
				</div>
			</div>
		</div>
	);
}

export default ProductDetailedCardWidget;
